<template>
<div v-if="value">
  <h1 class="w-full text-center underline">중대재해 발생 보고(건설업)</h1>
  <!-- 사업장 개요-->
  <div class="mt-8">
    <h4>1.사업장 개요</h4>
    <div class="mt-4 style-table">
      <!-- 사업장명 -->
      <div class="style-table-item" style="display: grid; grid-template-columns: 32px 1fr 1fr 1fr; border-right: none;">
        <label class="style-table-label">사<br>업<br>장<br>명</label>
        <div class="h-full">
          <div class="style-table-item" style="display: grid; grid-template-columns: 40px 1fr 1fr; align-items: center;">
            <label class="style-table-label">원<br>청</label>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; border-right: 1px solid #CDCDCD;">{{ value.company1 ? value.company1.com_name : ''}}</span>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; ">(대표: <span class="ml-2">{{ value.company1.com_ceo }}</span>)</span>
          </div>
          <div class="style-table-item" style="display: grid; grid-template-columns: 40px 1fr 1fr; align-items: center; border-bottom: none;">
            <label class="style-table-label">하<br>청</label>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; border-right: 1px solid #CDCDCD;">{{ value.company2 ? value.company2.com_name : ''}}</span>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; ">(대표: <span class="ml-2">{{ value.company2.com_ceo }}</span>)</span>
          </div>
        </div>
        <div class="h-full">
          <div class="style-table-item" style="display: grid; grid-template-columns: 140px 1fr ; align-items: center;">
            <label class="style-table-label">공사금액</label>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; ">{{ getInputA_7 | comma}}<span class="ml-2">백만원</span></span>
          </div>
          <div class="style-table-item" style="display: grid; grid-template-columns: 140px 1fr ; align-items: center;">
            <label class="style-table-label">공사기간</label>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; ">{{ 공사기간 }}</span>
          </div>
          <div class="style-table-item" style="display: grid; grid-template-columns: 140px 1fr ; align-items: center; border-bottom: none;">
            <label class="style-table-label">근로자수</label>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; ">{{ value.inputA_10 }}</span>
          </div>
        </div>
        <div class="h-full" style="display: grid; grid-template-rows: 1fr 1fr">
          <div class="h-full style-table-item" style="display: grid; grid-template-columns: 140px 1fr ; align-items: center;">
            <label class="h-full style-table-label">기술지도관계</label>
            <div style="height:100%; px-2">
              <div class="text-left mb-2">지도기관명 :</div>
              <div class="text-center">{{ value.inputA_13 }}</div>
            </div>
          </div>
          <div class="h-full style-table-item" style="display: grid; grid-template-columns: 140px 1fr ; align-items: center; border-bottom: none;">
            <label class="style-table-label">유해·위험방지<br>계획서 여부</label>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; ">
              <span class="print-radio"><i><feather-icon v-if="value.inputA_14 === '대상' " svgClasses="w-4 w-5" icon="CheckIcon" /></i>대상</span>
              <span class="print-radio ml-4"><i><feather-icon v-if="value.inputA_14 === '비대상' " svgClasses="w-4 w-5" icon="CheckIcon" /></i>비대상</span>
            </span>
          </div>
        </div>
      </div>

      <!-- 현장명-->
      <div class="style-table-item" style="display: grid; grid-template-columns: 32px 1fr 1fr 1fr; border-right: none;">
        <label class="style-table-label">현<br>장<br>명</label>
        <div class="h-full" style="display: grid; grid-template-rows: 1fr auto; align-items: center; border-right: 1px solid #CDCDCD;">
          <div style="text-align: center;">{{ value.inputA_5 }}</div>
          <div class="p-2 flex"><span>(소재지:</span><span class="mx-auto">{{value.inputA_6}}</span><span>)</span></div>
        </div>
        <div class="h-full">
          <div class="style-table-item" style="display: grid; grid-template-columns: 140px 1fr ; align-items: center;">
            <label class="style-table-label">공정율</label>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; ">{{ value.inputA_11 }}</span>
          </div>
          <div class="style-table-item" style="display: grid; grid-template-columns: 140px 1fr ; align-items: center; border-bottom: none;">
            <label class="style-table-label">발주처</label>
            <span style="display:flex; align-items: center; justify-content: center; height:100%; ">{{ value.inputA_12 }}</span>
          </div>
        </div>
        <div class="h-full">
          <div class="style-table-item h-full" style="display: grid; grid-template-columns: 140px 1fr ; grid-template-rows: 1fr; align-items: center; border-bottom: none;">
            <label class="style-table-label h-full">공정별<br>공사종류</label>
            <div class="h-full">
              <span style="display:flex; align-items: center; justify-content: center; height:50%; border-bottom: 1px solid #CDCDCD; ">{{ value.inputA_15 }}</span>
              <span style="display:flex; align-items: center; justify-content: center; height:50%; ">{{ value.inputA_16 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 2. 재해자 인적사항-->
  <div class="mt-8">
    <h4>2. 재해자 인적사항</h4>
    <div class="mt-4 style-table">
      <div style="display: grid; grid-template-columns: 137fr 220fr 137fr 137fr 137fr 137fr 200fr; border-bottom: 1px solid #cdcdcd;">
        <div class="style-table-label">성 명</div>
        <div class="style-table-label">주민등록번호</div>
        <div class="style-table-label">소 속</div>
        <div class="style-table-label">직 종</div>
        <div class="style-table-label">입사일자</div>
        <div class="style-table-label">동종경력</div>
        <div class="style-table-label">재해정도</div>
      </div>
      <div v-for="item in value.inputB_1"
           style="display: grid; grid-template-columns: 137fr 220fr 137fr 137fr 137fr 137fr 200fr;">
        <div class="style-table-item">{{item.name}}</div>
        <div class="style-table-item">{{item.rrn1}} - {{item.rrn2}}</div>
        <div class="style-table-item">{{item.group}}</div>
        <div class="style-table-item">{{item.typeOfWork}}</div>
        <div class="style-table-item">{{item.hireDate}}</div>
        <div class="style-table-item">{{ item.workYear}}년 {{ item.workMonth }}월</div>
        <div class="grid p-2" style="border-right: 1px solid #cdcdcd; border-bottom: 1px solid #cdcdcd;">
          <div class="w-full flex mb-2">
            <span class="print-checkbox"><i><feather-icon v-if="item.사망" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>사망(
            <span class="ml-auto mr-2">{{item.사망수}}</span>명)</div>
          <div class="w-full flex mb-2">
            <span class="print-checkbox"><i><feather-icon v-if="item.부상" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>부상(
            <span class="ml-auto mr-2">{{item.부상수}}</span>명)</div>
          <div class="w-full flex">(치료예상기간: <span class="ml-auto mr-2">{{ item.치료예상기간 }}</span>일)</div>
        </div>
      </div>
    </div>

    <!-- 3. 재해발생 내용 -->
    <div class="mt-8">
      <h4>3. 재해발생 내용</h4>
      <div class="mt-4 style-table" style="display: grid; grid-template-columns: repeat(4, 1fr); border-bottom:1px solid #cdcdcd;">
        <div class="grid" style="grid-template-columns: 80px 1fr; border-right:1px solid #cdcdcd;">
          <span class="style-table-label">일시</span>
          <div class="flex" style="justify-content: center; align-items: center;">{{ value.inputC_1 }}</div>
        </div>
        <div class="grid" style="grid-template-columns: 80px 1fr; border-right:1px solid #cdcdcd;">
          <span class="style-table-label">장소</span>
          <div class="flex" style="justify-content: center; align-items: center;">{{ value.inputC_2 }}</div>
        </div>
        <div class="grid" style="grid-template-columns: 80px 1fr; border-right:1px solid #cdcdcd;">
          <span class="style-table-label">발생<br>형태</span>
          <div class="flex" style="justify-content: center; align-items: center;">{{ value.inputC_3 }}</div>
        </div>
        <div class="grid" style="grid-template-columns: 80px 1fr; border-right:1px solid #cdcdcd;">
          <span class="style-table-label">기인물</span>
          <div class="flex" style="justify-content: center; align-items: center;">{{ value.inputC_4 }}</div>
        </div>
      </div>
    </div>

    <!-- 4. 재해발생개요(6하원칙) : -->
    <div class="mt-8">
      <h4>4. 재해발생개요(6하원칙) :</h4>
      <span class="mt-4 print-textarea" style="white-space: pre;">{{ value.inputD_1 }}</span>
    </div>

    <!-- 5. 사고후 조치사항 :-->
    <div class="mt-8">
      <h4>5. 사고후 조치사항 :</h4>
      <span class="mt-4 print-textarea" style="white-space: pre;">{{ value.inputD_2 }}</span>
    </div>

    <!-- 6. 기타 중요한 사항-->
    <div class="mt-8">
      <h4>6. 기타 중요한 사항</h4>
      <div class="mt-4">
        <p>- 산재보험 성립번호 : {{ value.inputD_3}}</p>
        <p>- 경찰서 조사관계 : {{ value.inputD_4}}</p>
        <p>- 사망사인 : {{ value.inputD_5}}</p>
      </div>
    </div>

    <div class="text-center mt-8">
      <p style="font-size: 22px;">위와같이 중대재해가 발생하였음을 보고합니다.</p>
      <p style="font-size: 22px; margin-top:27px;">
        <span>{{getCreatedAt.year}}.</span>
        <span class="ml-4">{{getCreatedAt.month}}.</span>
        <span class="ml-4">{{getCreatedAt.date}}.</span>
      </p>
    </div>
    <div class="grid mt-8" style="justify-content: flex-end">
      <div class="flex" style="width:370px; align-items: center; font-size:22px; "><span>보고자 :</span><span class="mx-auto">{{value.inputE_1}}</span><span>(인)</span></div>
      <div class="mt-2 flex" style="width:370px; align-items: center; font-size:22px; "><span>연락처 :</span><span class="mx-auto">{{value.inputE_2}}</span><span></span></div>
    </div>
    <div style="font-size: 26px;">
      {{value.inputE_3}} 귀하
    </div>

  </div>
</div>
</template>

<script>
export default {
  name: 'Print',
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
    getInputA_7 () {
      const Number = Math.floor(parseInt(this.removeComma(this.value.inputA_7)) / 1000)
      return Number
    },
    공사기간 () {
      const sDate = new Date(this.value.inputA_8).format('yyyy-MM-dd')
      const eDate = new Date(this.value.inputA_9).format('yyyy-MM-dd')
      return `${sDate} ~ ${eDate}`
    },
    getCreatedAt () {
      const date = this.header.full.split("-")
      return {
        year: date[0],
        month: date[1],
        date: date[2],
      }
    }
  },
  methods: {
    removeComma(str) {
      return str.replace(/,/g, "");
    },
  }
}
</script>

<style scoped>

</style>


<!-- table -->
<style scoped lang="scss">
.style-table {
  border-left:1px solid #CDCDCD; border-top:1px solid #CDCDCD;
}
.style-table-item { border-right: 1px solid #CDCDCD; border-bottom: 1px solid #CDCDCD; display: flex; align-items: center; justify-content: center; text-align: center; }
.style-table-label { width: 100%; height: 100%; padding-top:10px; padding-bottom: 10px; background-color: #ECECEC; border-right: 1px solid #CDCDCD; display: flex; align-items: center; justify-content: center; text-align: center;}
.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;

  & > i {
    width: 20px;
    height: 20px;
    border: 2px solid #cdcdcd;
    position: relative;
    margin-right: 6px;
  }
  & .feather-icon {
    transform: translateY(-4px);
  }
}

.print-radio {
  & > i {
    border-radius: 20px;
  }
}
</style>
